module.exports = __webpack_public_path__ + "static/bebe-agendamento-8403f2cfc5cb9b8fc75cef706ee1a521.jpg";